import {
  Component,
  Input,
  OnInit,
  SimpleChanges,
  TemplateRef,
} from "@angular/core";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { Subscription } from "rxjs";
import { AuthService } from "src/app/core/service/auth.service";
import { RestClientService } from "src/app/core/service/rest-client.service";
import { UtilitiesService } from "src/app/core/service/utilities.service";
import Swal from "sweetalert2";
import * as moment from "moment";
import * as _ from "lodash";
import { DomSanitizer } from "@angular/platform-browser";
import { PreviewProduitComponent } from "src/app/shared/components/preview-produit/preview-produit.component";
import { ModalDetailService } from "src/app/core/service/modal-detail.service";

@Component({
  selector: "app-modal-add-bareme",
  templateUrl: "./modal-add-bareme.component.html",
  styleUrls: ["./modal-add-bareme.component.scss"],
})
export class ModalAddBaremeComponent implements OnInit {
  listItems: Array<any> = [];
  items: Array<any> = [];
  itemToSave: any = {};
  currentProduit: any = {};
  itemBareme: any = {};
  filiale_id: any;
  uniteFonctionnelleSelected: any = {};
  // bsModalRef: BsModalRef;
  user: any = {};
  itemToSearch: any = {};
  currentPage: number = 0;
  itemsPerPage: number = 10;
  totalItems: number;
  show_password_field = true;
  busyGet: Subscription;
  busySave: Subscription;
  loading: boolean = false;
  endPoint: string = "bareme";
  title: string = "barème";
  createMessage = "";
  editMessage = "";
  deleteMessage = "";
  itemsParentFonctionnalites = [];
  itemsModeTarification: any = [];
  itemsModeFractionnement: any = [];
  gender = "M";
  itemsRole: any;
  itemsSpecialites: any;
  itemsCivilite: any = [];
  itemsGenre: any = [];
  itemsFiliale: any = [];
  searchKey: any;
  dateNais: any;
  bsValue: Date;
  selected_produit: any = {};
  imageName: string;
  imageDisplay: any;
  currentItemImage: {
    fileBase64: any;
    fileName: any;
    extension: any;
    typeDocument: string;
  };
  selectedUniteFoncId: any;
  selectedSpecialiteId: any;
  listSelectedUniteFonctionnelle = [];
  isAutoPassword = false;
  maxDate = new Date(
    new Date().getFullYear() - 18,
    new Date().getMonth() - 1,
    new Date().getDay()
  );
  minDate = new Date();
  itemsFucntParent: any[];
  itemsTypeGarant: any;
  itemsTypeAssurance: any[];
  itemsModeReconduction: any;
  isTarificationFamille: any;
  bsModalRefPreview: BsModalRef;
  itemsGarant: any;
  itemsGarantProduit: any;
  datasGarantieProduit: any = [];
  indiceTab: number = 0;
  dataProduitBareme: any = {};
  dataBareme: any = {};
  currentData: any;
  global_object: any;
  existingBareme: any;
  existingProduit: any;
  is_tarif_famille: boolean;
  isHideProduitForm: boolean = true;
  isDetailMode: any;
  indiceTab2: number = 0;
  itemsGarantieProduit: any = [];
  itemsPrimeTrancheAgeStatut: any = [];
  itemsConfigStatutTrancheAge: any = [];
  currentModeCalculPrime: string;
  itemsPrimeTrancheAge: any = [];
  itemsConfigPlafond: any = [];
  itemsPrimeBudget: any = [];
  itemsPrimeStatut: any = [];
  itemsModeCalculPrime: any = [];
  currentBareme: any = {};
  itemsAffectionProduitBareme: any = [];

  constructor(
    private authService: AuthService,
    public bsModalRef: BsModalRef,
    private restClient: RestClientService,
    private modalService: BsModalService,
    private utilities: UtilitiesService,
    private sanitizer: DomSanitizer,
    private detailModalService: ModalDetailService
  ) {
    // this.user = this.authService.currentUserValue;
    this.user = this.authService.getCurrentUser();
    // console.info('user-->: ',this.user)
    this.filiale_id = this.user.filiale_id;
    let text1 = this.gender == "M" ? "un" : "une";
    this.createMessage =
      "Vous êtes sur le point de créer " + text1 + " " + this.title;
    this.editMessage =
      "Vous êtes sur le point de modifier " + text1 + " " + this.title;
    this.deleteMessage =
      "Vous êtes sur le point de supprimer " + text1 + " " + this.title;

    setTimeout(() => {
      if (this.currentData) {
        this.itemToSave = { ...this.currentData };
        this.currentBareme = { ...this.currentData };
        this.currentProduit = this.currentBareme.produit_bareme
        this.currentModeCalculPrime = this.currentProduit ? this.currentProduit.mode_calcul_prime_codification : {}
        // if(this.itemToSave.produit_id){

        // }
        if (this.itemToSave.garant_id && this.itemToSave.produit_id) {
          this.getItemsProduitBareme()
          this.getItemsProduitByGarant(this.itemToSave.produit_id)
        }

      }
    }, 300);
  }
  getItemsProduitBareme(bareme?) {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {
        bareme_id: this.itemToSave.id || bareme.id
      },
    };

    this.busyGet = this.restClient
      .post("produitBareme/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.currentProduit = res["items"][0];
          } else {
            this.currentProduit = [];
          }
        },
        (err) => {
          this.currentProduit = [];
        }
      );
  }
  getItemsModeCalculPrime() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("modeCalculPrime/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsModeCalculPrime = res["items"];
          } else {
            this.itemsModeCalculPrime = [];
          }
        },
        (err) => {
          this.itemsModeCalculPrime = [];
        }
      );
  }
  confirmSaveItem(item) {
    console.log("item: ", item)
    console.log("this.currentProduit.mode_calcul_prime_id: ", this.currentProduit.mode_calcul_prime_id)
    //Check bareme
    if (!item || !item.garant_id) {
      this.utilities.showNotification(
        "snackbar-danger",
        "Veuillez renseigner garant !",
        "bottom",
        "center"
      );
      return;
    }
    if (!item.id && !item.codification) {
      item.codification = this.generateUniqueString()
    }
    if (!item.id && !item.code) {
      item.code = this.generateUniqueString()
    }
    // if(!item.id && !item.libelle){
    //   item.libelle = this.generateUniqueString()
    // }

    if (!item.id && (!item || !item.produit_id)) {
      this.utilities.showNotification(
        "snackbar-danger",
        "Veuillez renseigner produit !",
        "bottom",
        "center"
      );
      return;
    }
    if (!item || !item.libelle) {
      this.utilities.showNotification(
        "snackbar-danger",
        "Veuillez renseigner libelle !",
        "bottom",
        "center"
      );
      return;
    }

    if (!this.dataProduitBareme || !this.dataProduitBareme.id) {
      this.utilities.showNotification(
        "snackbar-danger",
        "Veuillez parametrer produit barème !",
        "bottom",
        "center"
      );
      return;
    }



    //check produit bareme


    //Cas mode de calcul par statut
    if (this.currentModeCalculPrime == "STATUT") {
      if (
        !this.dataProduitBareme ||
        !this.dataProduitBareme.mode_tarification_id
      ) {
        this.utilities.showNotification(
          "snackbar-danger",
          "Veuillez renseigner mode tarification !",
          "bottom",
          "center"
        );
        this.indiceTab2 = 1;
        return;
      }

      if (!this.validateConfigPlafond(this.itemsPrimeStatut)) {
        this.utilities.showNotification(
          "snackbar-danger",
          "Veuillez renseigner plafonds et plages d'age autorisées!",
          "bottom",
          "center"
        );
        this.indiceTab2 = 1;
        return;
      }

      if (!this.is_tarif_famille && this.hasPrimeNotFilled()) {
        this.utilities.showNotification(
          "snackbar-danger",
          "Veuillez veuillez rensigner les primes pour les bénéficiaire dont Nombre autorisé>0!",
          "bottom",
          "center"
        );
        this.indiceTab2 = 1;
        return;
      }
      if (this.is_tarif_famille && this.isAssurePrimeNotFilled()) {
        this.utilities.showNotification(
          "snackbar-danger",
          "Veuillez renseigner prime assuré!",
          "bottom",
          "center"
        );
        this.indiceTab2 = 1;
        return;
      }

      if (!this.itemsPrimeStatut || !this.itemsPrimeStatut.length) {
        this.utilities.showNotification(
          "snackbar-danger",
          "Veuillez renseigner primes statut!",
          "bottom",
          "center"
        );
        this.indiceTab2 = 1;
        return;
      }
    }
    //Cas mode de calcul par budget
    if (this.currentModeCalculPrime == "BUDGET") {
      if (!this.validateConfigPlafondBudget(this.itemsPrimeBudget)) {
        this.utilities.showNotification(
          "snackbar-danger",
          "Veuillez renseigner plafonds, plages d'age autorisées et budget!",
          "bottom",
          "center"
        );
        this.indiceTab2 = 1;
        return;
      }
    }

    if (this.currentModeCalculPrime == "TRANCHE-AGE") {
      console.log("this.itemsConfigPlafond: ", this.itemsConfigPlafond)
      if (!this.validateConfigPlafond(this.itemsConfigPlafond)) {
        this.utilities.showNotification(
          "snackbar-danger",
          "Veuillez renseigner plafonds et plages d'age autorisées!",
          "bottom",
          "center"
        );
        this.indiceTab2 = 1;
        return;
      }
      if (!this.itemsPrimeTrancheAge || !this.itemsPrimeTrancheAge.length) {
        this.utilities.showNotification(
          "snackbar-danger",
          "Veuillez renseigner primes tranche age!",
          "bottom",
          "center"
        );
        this.indiceTab2 = 1;
        return;
      }
    }
    if (this.currentModeCalculPrime == "TRANCHE-AGE-STATUT") {
      console.log(
        "this.itemsConfigStatutTrancheAge: ",
        this.itemsConfigStatutTrancheAge
      );
      console.log(
        "this.itemsPrimeTrancheAgeStatut: ",
        this.itemsPrimeTrancheAgeStatut
      );

      if (!this.validateConfigPlafond(this.itemsConfigStatutTrancheAge)) {
        this.utilities.showNotification(
          "snackbar-danger",
          "Veuillez renseigner plafonds et plages d'age autorisées!",
          "bottom",
          "center"
        );
        this.indiceTab2 = 1;
        return;
      }

      if (
        !this.itemsPrimeTrancheAgeStatut ||
        !this.itemsPrimeTrancheAgeStatut.length
      ) {
        this.utilities.showNotification(
          "snackbar-danger",
          "Veuillez renseigner primes tranche d'age statut!",
          "bottom",
          "center"
        );
        this.indiceTab2 = 1;
        return;
      }
    }

    if (!this.itemsGarantieProduit || !this.itemsGarantieProduit.length) {
      this.utilities.showNotification(
        "snackbar-danger",
        "Veuillez renseigner garantie(s)!",
        "bottom",
        "center"
      );
      this.indiceTab2 = 2;
      return;
    }

    console.log("this.dataBareme: ", this.dataBareme);

    Swal.fire({
      title: this.title,
      text: this.dataBareme?.id ? this.editMessage : this.createMessage,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#0665aa",
      cancelButtonColor: "#d33",
      confirmButtonText: "Oui",
      cancelButtonText: "Non",
    }).then((result) => {
      if (result.value) {
        this.saveItem(item);
      }
    });
  }

  hasPrimeNotFilled(): boolean {
    console.log("checking: ", this.itemsPrimeStatut)
    return this.itemsPrimeStatut.some(
      (isi) => isi.nombre_autorise > 0 && (!isi.prime || isi.prime == 0)
    );
  }
  isAssurePrimeNotFilled(): boolean {
    return this.itemsPrimeStatut.some(
      (isi) => isi.codification == "A" && !isi.prime
    );
  }

  validateConfigPlafond(configPlafond): boolean {
    return (
      configPlafond.length &&
      configPlafond.every((item) => {
        // If nombre_autorise is greater than 0, ensure plafond, age_min, and age_max are not null/undefined
        if (item.nombre_autorise > 0) {
          return (
            item.plafond !== null &&
            item.plafond !== undefined &&
            item.plafond !== "" &&
            item.plafond !== 0 &&
            item.age_min !== null &&
            item.age_min !== undefined &&
            item.age_min !== "" &&
            item.age_max !== null &&
            item.age_max !== undefined &&
            item.age_max !== ""
          );
        }
        return true; // If nombre_autorise is 0 or less, it's valid
      })
    );
  }
  validateConfigPlafondBudget(configPlafond): boolean {
    console.log("configPlafond budget: ", JSON.stringify(configPlafond));
    return (
      configPlafond.length &&
      configPlafond.every((item) => {
        // If nombre_autorise is greater than 0, ensure plafond, age_min, and age_max are not null/undefined
        if (item.nombre_autorise > 0) {
          return (
            item.plafond !== null &&
            item.plafond !== undefined &&
            item.plafond !== "" &&
            item.age_min !== null &&
            item.age_min !== undefined &&
            item.age_min !== "" &&
            item.age_max !== null &&
            item.age_max !== undefined &&
            item.age_max !== "" &&
            item.budget !== null &&
            item.budget !== undefined &&
            item.budget !== ""
          );
        }
        return true; // If nombre_autorise is 0 or less, it's valid
      })
    );
  }

  getItemsModeTarification() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.restClient.post("modeTarification/getByCriteria", request).subscribe(
      (res) => {
        if (res && res["items"]) {
          this.itemsModeTarification = _.orderBy(
            res["items"],
            ["libelle"],
            ["asc"]
          );
          // console.log('this.itemToSave.mode_tarification_id: ',this.itemToSave.mode_tarification_id)
          // this.mode_tarification_selected = this.itemsModeTarification.filter(
          //   (imt) => imt.id == this.itemToSave.mode_tarification_id
          // )[0];
          // this.check_if_is_famille();
        } else {
          this.itemsModeTarification = [];
        }
      },
      (err) => {
        this.itemsModeTarification = [];
      }
    );
  }


  onChangeGarantieForm(event) {
    console.log('event onChangeGarantieForm: ', event)
    this.itemsGarantieProduit = event
  }
  onChangePrimeStatutForm(event) {
    console.log('event onChangePrimeStatutForm: ', event)
    // this.itemsGarantieProduit = event
    this.itemsPrimeStatut = event
  }
  onChangePrimeBudgetForm(event) {
    console.log('event onChangePrimeBudgetForm: ', event)
    this.itemsPrimeBudget = event
  }
  onChangePrimeTrancheAgeForm(event) {
    console.log('event onChangePrimeTrancheAgeForm: ', event)
    this.itemsPrimeTrancheAge = event.primesTrancheAge
    this.itemsConfigPlafond = event.configPlafond
    console.log('this.itemsConfigPlafond: ', this.itemsConfigPlafond)
    console.log('this.itemsPrimeTrancheAge: ', this.itemsPrimeTrancheAge)

  }

  onChangePrimeTrancheAgeStatutForm(event) {

    console.log('event onChangePrimeTrancheAgeStatutForm: ', event)
    this.itemsPrimeTrancheAgeStatut = event.primesTrancheAgeStatut
    this.itemsConfigStatutTrancheAge = event.configPlafondTaStatut
  }

  onChangeModeTarification(event) {
    console.log('event onChangeModeTarification: ', event)
    this.dataProduitBareme.mode_tarification_id = event.mode_tarification_id
    this.is_tarif_famille = event.is_tarif_famille
    console.log('this.is_tarif_famille: ', this.is_tarif_famille)
    console.log('this.dataProduitBareme.mode_tarification_id: ', this.dataProduitBareme.mode_tarification_id)
  }


  saveItem(item) {
    this.loading = true;


    let itemAEnregistrer = Object.assign({}, item);
    // this.dataProduitBareme
    if (this.currentModeCalculPrime == 'STATUT') {
      if (this.itemsPrimeStatut && this.itemsPrimeStatut.length) {
        this.itemsPrimeStatut.map(ips => {
          ips.garant_id = this.itemToSave.garant_id
          ips.mode_calcul_prime_id = this.currentProduit.mode_calcul_prime_id
        })
      }
      this.dataProduitBareme.datasPrimeProduit = this.itemsPrimeStatut

    }
    if (this.currentModeCalculPrime == 'BUDGET') {
      if (this.itemsPrimeBudget && this.itemsPrimeBudget.length) {
        this.itemsPrimeBudget.map(ips => {
          ips.garant_id = this.itemToSave.garant_id
          ips.mode_calcul_prime_id = this.currentProduit.mode_calcul_prime_id
        })
      }
      this.dataProduitBareme.datasPrimeProduit = this.itemsPrimeBudget
      this.dataProduitBareme.budget = this.itemsPrimeBudget[0].budget

    }
    if (this.currentModeCalculPrime == 'TRANCHE-AGE') {
      delete this.dataProduitBareme.datasPrimeProduit
      // debugger

      if (this.itemsConfigPlafond && this.itemsConfigPlafond.length) {
        this.itemsConfigPlafond.map(ips => {
          ips.garant_id = this.itemToSave.garant_id
          // ips.mode_calcul_prime_id=this.currentProduit.mode_calcul_prime_id
        })
      }

      if (this.itemsPrimeTrancheAge && this.itemsPrimeTrancheAge.length) {
        this.itemsPrimeTrancheAge.map(ips => {
          ips.garant_id = this.itemToSave.garant_id
          // ips.mode_calcul_prime_id=this.currentProduit.mode_calcul_prime_id
        })
      }

      this.dataProduitBareme.itemsConfigPlafond = this.itemsConfigPlafond
      this.dataProduitBareme.itemsPrimeTrancheAge = this.itemsPrimeTrancheAge



    }
    if (this.currentModeCalculPrime == 'TRANCHE-AGE-STATUT') {
      if (this.itemsConfigStatutTrancheAge && this.itemsConfigStatutTrancheAge.length) {
        this.itemsConfigStatutTrancheAge.map(ips => {
          ips.garant_id = this.itemToSave.garant_id
          // ips.mode_calcul_prime_id=this.currentProduit.mode_calcul_prime_id
        })
      }

      if (this.itemsPrimeTrancheAgeStatut && this.itemsPrimeTrancheAgeStatut.length) {
        this.itemsPrimeTrancheAgeStatut.map(ips => {
          ips.garant_id = this.itemToSave.garant_id
          // ips.mode_calcul_prime_id=this.currentProduit.mode_calcul_prime_id
        })
      }

      this.dataProduitBareme.itemsConfigStatutTrancheAge = this.itemsConfigStatutTrancheAge
      this.dataProduitBareme.itemsPrimeTrancheAgeStatut = this.itemsPrimeTrancheAgeStatut
    }
    this.dataProduitBareme.datasGarantie = this.itemsGarantieProduit

    if (itemAEnregistrer.id)
      delete itemAEnregistrer.produit_bareme
    itemAEnregistrer.dataProduitBareme = this.dataProduitBareme

    // itemAEnregistrer.dataProduitBareme.mode_calcul_prime_id = this.currentProduit.mode_calcul_prime_id
    itemAEnregistrer.filiale_id = this.user.filiale_id


    if (this.itemsAffectionProduitBareme && this.itemsAffectionProduitBareme.length) {
      itemAEnregistrer.datasAffectionProduitBareme = this.itemsAffectionProduitBareme

    }


    var request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      datas: [itemAEnregistrer],
    };

    this.busySave = this.restClient
      .post(
        this.endPoint + "" + (itemAEnregistrer.id ? "/update" : "/create"),
        request
      )
      .subscribe(
        (res) => {
          console.info("resul", res);
          this.loading = false;

          if (!res["hasError"]) {
            this.utilities.showNotification(
              "snackbar-success",
              this.utilities.formatMsgServeur(res["status"]["message"]),
              "bottom",
              "center"
            );
            // this.currentPage = 0;
            // this.bsModalRef.hide();
            this.currentBareme = Object.assign({}, res["item"]);
            this.currentModeCalculPrime = this.currentProduit ? this.currentProduit.mode_calcul_prime_codification : {}
            // this.itemBareme = Object.assign({}, res["item"]);
            // currentProduit && currentProduit.id
            console.log("this.currentProduit after saving bareme: ", this.currentProduit)
            this.currentProduit = { ...this.currentProduit }
            if (!this.currentProduit || !this.currentProduit.id)
              this.getItemsProduitBareme(this.currentBareme)
          } else {
            if (res["status"] && res["status"]["message"]) {
              this.utilities.showNotification(
                "snackbar-danger",
                this.utilities.formatMsgServeur(res["status"]["message"]),
                "bottom",
                "center"
              );
            }
          }
        },
        (err) => {
          this.utilities.showNotification(
            "snackbar-danger",
            this.utilities.getMessageEndPointNotAvailble(),
            "bottom",
            "center"
          );
          this.loading = false;
        }
      );
  }

  generateUniqueString() {
    // Get current timestamp in milliseconds
    var timestamp = new Date().getTime();

    // Generate a random number
    var randomNumber = Math.floor(Math.random() * 1000000); // Adjust range as needed

    // Concatenate timestamp and random number
    var uniqueString = timestamp.toString() + randomNumber.toString();

    return uniqueString;
  }

  selectedChangeValue(event: any) {
    console.log("le event selectedChangeValue", event);

    if (!event) this.indiceTab = 0;

    this.indiceTab = event;
  }
  selectedChangeValue2(event: any) {
    console.log("le event selectedChangeValue", event);

    if (!event) this.indiceTab2 = 0;

    this.indiceTab2 = event;
  }

  getItemsGarant() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("garant/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsGarant = _.orderBy(res["items"], ["libelle"], ["asc"]);
          } else {
            this.itemsGarant = [];
          }
        },
        (err) => {
          this.itemsGarant = [];
        }
      );
  }

  getItemsProduitByGarant(produit_id?) {
    this.currentProduit = {}
    this.itemsGarantProduit = [];
    this.itemToSave.produit_id = "";

    if (!this.itemToSave.garant_id) return;
    this.itemsGarantProduit = [];
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {
        garant_id: this.itemToSave.garant_id,
      },
    };

    this.busyGet = this.restClient
      .post("produit/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsGarantProduit = res['items']
            this.itemsGarantProduit.sort((a, b) =>
              this.customSortProduit(a, b)
            );
            if (produit_id)
              this.itemToSave.produit_id = produit_id
          } else {
            this.itemsGarantProduit = [];
          }
        },
        (err) => {
          this.itemsGarantProduit = [];
        }
      );
  }
  customSortProduit(a, b) {
    const desiredOrder = ["STATUT", "TRANCHE-AGE", "TRANCHE-AGE-STATUT", "BUDGET"];
    return desiredOrder.indexOf(a.mode_calcul_prime_codification) - desiredOrder.indexOf(b.mode_calcul_prime_codification);
  }

  onChangeProduit() {
    this.currentProduit = this.itemsGarantProduit.filter(
      (igp) => igp.id == this.itemToSave.produit_id
    )[0];
    console.log("this.currentProduit: ", this.currentProduit);
    this.currentBareme = { ...this.itemToSave }
    console.log("this.currentBareme: ", this.currentBareme);

    //a revoir
    if (this.itemsModeCalculPrime && this.itemsModeCalculPrime.length) {
      this.currentModeCalculPrime = this.itemsModeCalculPrime.find(
        (imcp) => imcp.id == this.currentProduit.mode_calcul_prime_id
      ).codification;
      console.log("this.currentModeCalculPrime: ", this.currentModeCalculPrime)
    }


  }

  openDetailModal(type) {
    let data = {};
    if (type == "garant") {
      data = this.itemsGarant.filter(
        (ig) => ig.id == this.itemToSave.garant_id
      )[0];
      this.detailModalService.onPenDetailModal(data, type, 80);
    }
    if (type == "produit") {
      data = this.itemsGarantProduit.filter(
        (igp) => igp.id == this.itemToSave.produit_id
      )[0];
      this.detailModalService.onPenDetailModal(data, type, 90);
    }
  }
  onHideFormEvent() {
    this.bsModalRef.hide()
  }
  onUpdateProduitBareme(event) {
    this.dataProduitBareme = event;
    console.log("dataProduitBareme: ", this.dataProduitBareme);
  }

  onChangeAffectionBaremeForm(event) {
    console.log('event onChangeGarantieForm: ', event)
    this.itemsAffectionProduitBareme = event
  }

  ngOnInit() {
    this.getItemsGarant();
    this.getItemsModeCalculPrime();
  }
}
